const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/store/featureFlags.ts';
import { IActionHandlersMap, makeReducer, ReducerState } from '@cistec/common_web/defs/actionTypes';
import { loadFeatureFlags, REQUEST_ACTION_TYPES_LOAD_FEATURE_FLAGS } from 'App/actions/featureFlag';
import { addRequestActionHandlers, getData, useRemoteData2 } from '@cistec/common_web/utils/redux4Requests';
import { createSelector } from 'reselect';
import { PatAppStoreState } from './setup/rootReducer';

export interface FeatureConfiguration {
    appointment: {
        BookingCommentRequir: boolean;
        appointmentDocs: boolean;
        cancelAppointment: boolean;
        IAMCancelAppointment: boolean;
        BookingCommentField: boolean;
        BookingDataFields: boolean;
        showResponsibilities: boolean;
        showPastAppointments: boolean;
    };
    dashboard: {
        calendar: boolean;
        report: boolean;
        iamDialog: boolean;
        showIdentityProof: boolean;
        medication: boolean;
        invoices: boolean;
        showHospitalImg: boolean;
        synedraViewer: boolean;
        appointmentOnCard: boolean;
        eCheckin: boolean;
        disableAutoEcheckin: boolean;
        yourNextAppointment: boolean;
        appointmentBooking: boolean;
        showSurgeryCard: boolean;
    };
    login: {
        allowIAM: boolean;
        allowRegristration: boolean;
        dialogSMSRecieved: boolean;
    };
    reports: {
        showDocumentReadConf: boolean;
    };
    utils: {
        allowMatamoTrack: boolean;
        useNotification: boolean;
    };
}

const DEFAULT_FEATUREFLAGS_CONFIG: FeatureConfiguration = {
    appointment: {
        appointmentDocs: false,
        showResponsibilities: false,
        cancelAppointment: false,
        IAMCancelAppointment: false,
        BookingCommentField: false,
        BookingCommentRequir: false,
        BookingDataFields: false,
        showPastAppointments: false,
    },
    dashboard: {
        iamDialog: false,
        eCheckin: false,
        appointmentOnCard: false,
        disableAutoEcheckin: false,
        calendar: false,
        yourNextAppointment: false,
        appointmentBooking: false,
        medication: false,
        report: false,
        invoices: false,
        synedraViewer: false,
        showSurgeryCard: false,
        showIdentityProof: false,
        showHospitalImg: false,
    },
    login: {
        allowIAM: false,
        allowRegristration: false,
        dialogSMSRecieved: false,
    },
    reports: {
        showDocumentReadConf: false,
    },
    utils: {
        allowMatamoTrack: false,
        useNotification: false,
    },
};

const handlers: IActionHandlersMap = {};

addRequestActionHandlers(handlers, REQUEST_ACTION_TYPES_LOAD_FEATURE_FLAGS);
export const featureFlagsReducer = makeReducer(handlers);

// SELECTORS

const selectReducerState = (state: PatAppStoreState): ReducerState => state.featureFlags;

export const selectFeatureFlags = createSelector(
    [selectReducerState],
    (state: ReducerState): FeatureConfiguration => getData(state) ?? DEFAULT_FEATUREFLAGS_CONFIG
);

// HOOKS

export function useFeatureFlags() {
    return useRemoteData2('featureFlags', {
        request: dispatch => dispatch(loadFeatureFlags()),
        select: selectFeatureFlags,
    });
}
